'use strict';

angular.module('ticketAssignment')
    .controller('TicketAdminCtrl', [
        '$scope', 'ticketsAdminViewModel', '$state',
        function ($scope, viewModel, $state) {
            $scope.model = new viewModel();
        }
    ]);